exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-form td[data-v-4932378f]:last-child{border-right:none}.table-form .table-body[data-v-4932378f]{word-break:break-all;font-size:14px}.table-form .table-body tr[data-v-4932378f]:last-child{border:none}.table-form .table-body td[data-v-4932378f]:first-child{border-left:none}[data-v-4932378f] .el-card .el-card__header{padding:10px}[data-v-4932378f] .custom-card{border-bottom:none!important}[data-v-4932378f] .el-card .el-card__header{padding:0!important}", ""]);

// exports
